import { Component, Input } from "@angular/core";

import { ExternalReference } from '@models/mood/dataset-metainfo';
import { EXTERNAL_REFERENCE_TYPE_PLATFORMS } from "src/app/constant";

@Component({
  selector: 'mood-metainfo-reference',
  templateUrl: 'metainfo-reference.component.html',
  styleUrls: ['metainfo-reference.component.scss']
})
export class DatasetMetainfoReferenceComponent {
  @Input() reference!: ExternalReference;

  constructor() { }

  public get referenceLabel() {
    let label = this.reference.label;

    if(label) {
      label += ` (${this.getPlatformLabel})`;
    } else {
      label = this.getPlatformLabel;
    }
    return label;
  }

  private get getPlatformLabel() {
    switch (this.reference.platform) {
      case 'ZENODO':
        return 'Zenodo';

      case 'GEONETWORK':
        return 'GeoNetwork';

      default:
        return;
    }
  }

  public get getPlatformUrl() {
    const platformPrefix = EXTERNAL_REFERENCE_TYPE_PLATFORMS.find(platform => platform.code === this.reference.platform);
    return `${platformPrefix?.prefix}${this.reference.identifier}`;
  }

  public openExternalReference() {
    window.open(this.getPlatformUrl, '_blank');
  }
}
